import paymentmethods from './paymentmethods';
import dynamicpaymentmethods from './dynamicpaymentmethods';
import frequencyamounts from './frequencyamounts';
import zipcodepostcodeapi from './zipcodepostcodeapi';
import housenumberadditionpostcodeapi from './housenumberadditionpostcodeapi';
import products from './products';
export default {
    paymentmethods: paymentmethods,
    dynamicpaymentmethods: dynamicpaymentmethods,
    frequencyamounts: frequencyamounts,
    zipcodepostcodeapi: zipcodepostcodeapi,
    housenumberadditionpostcodeapi: housenumberadditionpostcodeapi,
    products: products
};
